import React, { PureComponent } from 'react'
import './print.less'
import {Modal,Button} from 'antd'
import {subStr} from '../../../utills/subStringUtill'
class TrackModal extends PureComponent {
    hideModal = () =>{
        const {hideModal} = this.props
        hideModal()
    }

    render() {
        const {previewVisiable,previewData,} = this.props
        return (
            <Modal
                visible={previewVisiable}
                onCancel={this.hideModal}
                className='trackModel-style'
                footer={[<Button onClick={this.hideModal}>关闭</Button>]}
            >
                <div className='print-box' style={{width:'700px',height:'auto',margin: '0 auto' }}>
                    <h2>货运委托协议书</h2>
                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <th width="15%">
                                订单编号
                                <div className="en">Order No.</div>
                            </th>
                            <td width="35%">{previewData.orderNo}</td>
                            <th width="15%">
                               下单日期
                                <div className="en">Date</div>
                            </th>
                            <td width="35%">{subStr(previewData.createdDt)}</td>
                        </tr>
                        <tr>
                            <th>
                                发货企业名称地址
                                <div className="en">Shipper(Full Name & Addressa)</div>
                            </th>
                            <td colSpan="3">
                                {previewData.shipper} / {previewData.shipperAddr}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                境外收货方名称地址
                                <div className="en">Consignee(Full Name & Addressa)</div>
                            </th>
                            <td colSpan="3">
                                {previewData.consignee} / {previewData.consigneeAddr}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                通知方名称地址
                                <div className="en">Notify Party(Full Name & Addressa)</div>
                            </th>
                            <td colSpan="3">
                                {previewData.notifyParty} / {previewData.notifyPartyAddr}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                起运地
                                <div className="en">The Origin of Shipment</div>
                            </th>
                            <td>{previewData.originCountry}&nbsp;{previewData.originCity}</td>
                            <th>
                                目的地
                                <div className="en">The Destination of Shipment</div>
                            </th>
                            <td>{previewData.destinationStartCountry}&nbsp;{previewData.destinationStartCity}<br/>{previewData.destinationCountry}&nbsp;{previewData.destinationCity}</td>
                        </tr>
                        <tr>
                            <th>
                                集装箱数量
                                <div className="en"></div>
                            </th>
                            <td>{previewData.containerNum}</td>
                            <th>
                                集装箱类型
                                <div className="en"></div>
                            </th>
                            <td>{previewData.containerType}</td>
                        </tr>
                        <tr>
                            <th>
                                贸易时间
                                <div className="en">Trade Date</div>
                            </th>
                            <td>{subStr(previewData.tradeDt)}</td>
                            <th>
                                采购单号
                                <div className="en">Purchase order No</div>
                            </th>
                            <td>{previewData.purchaseNo}</td>
                        </tr>
                        <tr>
                            <th>
                                发票编号
                                <div className="en">Invoice No</div>
                            </th>
                            <td>{previewData.invNo}</td>
                            <th>
                                包装
                                <div className="en">Package</div>
                            </th>
                            <td>{previewData.packageKind}</td>
                        </tr>
                        <tr>
                            <th>
                                仓库地点
                                <div className="en">The Place of Delivery</div>
                            </th>
                            <td>{previewData.deliveryPlace}</td>
                            <th>
                                预计提货时间
                                <div className="en">The Estimated Time of Taking Delivery</div>
                            </th>
                            <td>{previewData.deliveryEstimateDt}</td>
                        </tr>
                        <tr>
                            <th>
                                仓库联系人
                                <div className="en">Contact</div>
                            </th>
                            <td>{previewData.contact}</td>
                            <th>
                                仓库联系人电话
                                <div className="en">Tel</div>
                            </th>
                            <td>{previewData.contactTel}</td>
                        </tr>
                        </tbody>

                    </table>
                    <table className="tablestyle table3">
                        <tbody>
                            <tr>
                                <td align="center">
                                    货物详细情况 Cargo Particulars
                                </td>
                            </tr>
                        </tbody>

                    </table>

                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <th>
                                唛码标记Marks
                                <div className="en">Marks</div>
                            </th>
                            <th>
                                品名(中文)
                            </th>
                            <th>
                                品名(英文)
                            </th>
                            <th>
                                国内 HS Code
                            </th>
                            <th>
                                国外 HS Code
                            </th>
                            <th>
                                箱数
                                <div className="en">CTNS</div>
                            </th>
                            <th>
                                件数
                                <div className="en">PCS</div>
                            </th>
                            <th>
                                毛重(Kg)
                                <div className="en">G/W</div>
                            </th>
                            <th>
                                净重(Kg)
                                <div className="en">N/W</div>
                            </th>
                            <th>
                                体积(CBM)
                                <div className="en">Measurement</div>
                            </th>
                            <th>
                                单价/币制
                                <div className="en">Value unit</div>
                            </th>
                            <th>
                                总价/币制
                                <div className="en">Value & Currency</div>
                            </th>
                            <th>
                                成分
                            </th>
                            <th>
                                用途
                            </th>
                        </tr>

                        {previewData.packageManageVos ? previewData.packageManageVos.map(c => (
                            <tr key={c.id}>
                                <td>{c.boxNo}</td>
                                <td>{c.name}</td>
                                <td>{c.nameEn}</td>
                                <td>{c.hscode}</td>
                                <td>{c.oHscode}</td>
                                <td>{c.num}</td>
                                <td>{c.pcsNumber}</td>
                                <td>{c.grossWeight}</td>
                                <td>{c.netWeight}</td>
                                <td>{c.volume}</td>
                                <td>{c.value}/{c.currency}</td>
                                <td>{c.totalValue}/{c.currency}</td>
                                <td>{c.ingredient}</td>
                                <td>{c.application}</td>
                            </tr>
                        )):null}
                        </tbody>

                    </table>
                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <td width="100%" className='textleft' rowSpan="4" valign="top">
                                声明事项：
                                <div className="en">Declarations</div>
                                <div>
                                    <div>
                                        1、请准确、完整、如实填写委托书。如有漏项、错项、不完全项将会影响贵司及时成功订舱及顺利发运，因信息有误导致的相关事宜由贵司自行承担。
                                    </div>
                                    <div>
                                        2、如装箱时间有任何更改，请于装箱日期前2个工作日通知阳光捷通确认。
                                    </div>
                                    <div>
                                        3、集装箱还箱地——需按要求还箱至指定还箱场站。
                                    </div>
                                    <div>
                                        4、提货前3日贵司需登录系统下发委托单。
                                    </div>
                                    <div>
                                        5、如有任何疑问，请联系我部门，联系人：廖凯  电话：13588269271。
                                    </div>
                                </div>
                                <div className='shipper-seal'>
                                    托运人签章:
                                    <div className="en">Shipper Seal</div>
                                </div>
                            </td>
                        </tr>
                        </tbody>

                    </table>

                    <div className="line"></div>
                </div>
            </Modal>
        )
    }
}
export default TrackModal
